import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { Circle } from "lucide-react"

import { cn } from "@/lib/utils"

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return (<RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />);
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        // Stage 5 mobile fix (retest iteration_16): the actual bounding
        // box on mobile is now 44×44 (min-h-11 min-w-11) so strict
        // getBoundingClientRect audits pass WCAG 2.2 target-size. The
        // visible dot stays 16×16 via the nested <span> below. Desktop
        // (`sm:`) reverts to the compact 16×16 hitbox.
        "min-h-11 min-w-11 sm:min-h-0 sm:min-w-0 sm:h-4 sm:w-4 inline-flex items-center justify-center rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring group",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}>
      <span aria-hidden="true" className="pointer-events-none block h-4 w-4 rounded-full border border-primary text-primary shadow bg-transparent">
        <RadioGroupPrimitive.Indicator className="flex h-full w-full items-center justify-center">
          <Circle className="h-3.5 w-3.5 fill-primary" />
        </RadioGroupPrimitive.Indicator>
      </span>
    </RadioGroupPrimitive.Item>
  );
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
